/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Modal, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { StickyContainer, Sticky } from 'react-sticky';
import ModalActivityTab1 from './ModalActivityTab1';
import ModalActivityTab2 from './ModalActivityTab2';
import UserService from '../../../services/UserService';
import { useEffect, useState } from 'react';
import DataFlowService from '../../../services/DataFlow.service';

const ModalActivity = ({
    open,
    search,
    handelClose,
    mode,
    setOpenSuccess,
    detailInfo,
}) => {
    const { TabPane } = Tabs;
    const { t, i18n } = useTranslation();
    const [form] = Form.useForm();
    const [form2] = Form.useForm();
    const [nameList, setNameList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [activityName, setActivityName] = useState({
        value: '',
    });
    const [currentSelectBu, setCurrentSelectBu] = useState('');
    const [validateFile, setValidateFile] = useState(false);
    const [files, setFiles] = useState([]);
    const [getFiles, setGetFiles] = useState([]);
    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    useEffect(() => {
        getDepartmentList();
    }, [i18n.language]);

    const getDepartmentList = async () => {
        await DataFlowService.getDepartmentList().then((res) => {
            let option = [];
            res?.data?.resultData?.forEach((element) => {
                option.push({
                    value:
                        i18n.language === 'en'
                            ? element.nameEn
                            : element.nameTh,
                    id: element.departmentId,
                });
            });
            setDepartmentList([...option]);
        });
    };

    useEffect(() => {
        if (!admin && open) {
            form.setFieldsValue({
                departmentId: departmentList[0].id,
            });
            form2.setFieldsValue({
                departmentId: departmentList[0].id,
            });
            setCurrentSelectBu(departmentList[0].id);
        }

        if (mode === 'editActivity') {
            setCurrentSelectBu(detailInfo?.departmentId);
            form.setFieldsValue({
                departmentId: detailInfo?.departmentId,
                businessProcessId: detailInfo?.businessProcessId,
                activityName: detailInfo?.activityName,
            });
        }
    }, [open]);

    const renderTabBar = (props, DefaultTabBar) => (
        <Sticky bottomOffset={80}>
            {({ style }) => (
                <DefaultTabBar
                    {...props}
                    className="bg-white z-50"
                    style={{ ...style }}
                />
            )}
        </Sticky>
    );

    return (
        <Modal
            className="_modal"
            footer={false}
            open={open}
            afterClose={() => {
                setValidateFile(false);
                setFiles([]);
                setGetFiles([]);
                form2.resetFields();
            }}
            onCancel={() => {
                handelClose();
                setValidateFile(false);
                form.resetFields();
                setNameList([]);
                setActivityName({
                    value: '',
                });
            }}
        >
            <div>
                <div className="text-2xl font-semibold mb-6 text-center">
                    {mode === 'addActivity'
                        ? t('RoPA.AddActivity')
                        : t('Edit Activity')}
                </div>
                {mode === 'addActivity' ? (
                    <StickyContainer>
                        <Tabs
                            onChange={() => {
                                setValidateFile(false);
                                setFiles([]);
                                form.resetFields();
                                form2.resetFields();
                                if (!admin && open) {
                                    form.setFieldsValue({
                                        departmentId: departmentList[0]?.id,
                                        businessProcessId: undefined,
                                        activityName: '',
                                    });
                                    form2.setFieldsValue({
                                        departmentId: departmentList[0]?.id,
                                        file: '',
                                    });
                                    setCurrentSelectBu(departmentList[0]?.id);
                                }
                            }}
                            renderTabBar={renderTabBar}
                            centered
                        >
                            <TabPane tab={t('RoPA.AddActivity')} key={1}>
                                <ModalActivityTab1
                                    mode={mode}
                                    handelClose={handelClose}
                                    isRoleAdmin={admin}
                                    form={form}
                                    nameList={nameList}
                                    setNameList={setNameList}
                                    departmentList={departmentList}
                                    setOpenSuccess={setOpenSuccess}
                                    activityName={activityName}
                                    setActivityName={setActivityName}
                                    currentSelectBu={currentSelectBu}
                                    setCurrentSelectBu={setCurrentSelectBu}
                                />
                            </TabPane>
                            <TabPane tab={t('RoPA.ImportActivity')} key={2}>
                                <ModalActivityTab2
                                    search={search}
                                    handelClose={handelClose}
                                    departmentList={departmentList}
                                    setOpenSuccess={setOpenSuccess}
                                    form2={form2}
                                    isRoleAdmin={admin}
                                    setValidateFile={setValidateFile}
                                    validateFile={validateFile}
                                    files={files}
                                    setFiles={setFiles}
                                    getFiles={getFiles}
                                    setGetFiles={setGetFiles}
                                />
                            </TabPane>
                        </Tabs>
                    </StickyContainer>
                ) : (
                    <div>
                        <ModalActivityTab1
                            mode={mode}
                            handelClose={handelClose}
                            isRoleAdmin={admin}
                            form={form}
                            nameList={nameList}
                            setNameList={setNameList}
                            departmentList={departmentList}
                            setOpenSuccess={setOpenSuccess}
                            activityName={activityName}
                            setActivityName={setActivityName}
                            currentSelectBu={currentSelectBu}
                            setCurrentSelectBu={setCurrentSelectBu}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
};
export default ModalActivity;
